import { api } from '@marketplace-web/core-api/core-api-client-util'

import { BankAccountsResp } from '../types/bank-account'

export const getBankAccounts = () => api.get<BankAccountsResp>('/bank_accounts')
